<script lang="ts" setup>
import "./MTooltipBasic.scss";
import { computed } from "vue";
import type { MTooltipBasicProps } from "./MTooltipBasic.props";
import { mTooltipBasicDefaults } from "./MTooltipBasic.props";

const props = withDefaults(defineProps<MTooltipBasicProps>(), mTooltipBasicDefaults);

const cssVars = computed(() => ({
  "--m-tooltip-basic-offset-x": `${props.offset[0]}px`,
  "--m-tooltip-basic-offset-y": `${props.offset[1]}px`,
}));

const positionClass = computed(() => `m-tooltip-basic--${props.position}`);
</script>

<template>
  <span class="m-tooltip-basic" :class="positionClass" role="tooltip" :style="cssVars">
    <span class="m-tooltip-basic__text"><slot /></span>
  </span>
</template>
